import { useEffect, useState } from "react";

import { useGetProfileData } from "_common/hooks/auth";
import { useSetComments }    from "_common/hooks/stream";

const useIVS = () => {
	const [ message, setMessage ] = useState ( [] );
	const userProfile             = useGetProfileData ();
	const setCommentsState        = useSetComments ();

	const updateComments = comment => {
		if ( !comment )
			return;

		setCommentsState ( prevState => [ ...prevState, comment ].slice ( -250 ) );
	};

	useEffect ( () => {
		const eventName = message?.attributes?.eventName;
		let commentText = message?.content;

		if ( commentText === "NO_CONTENT" ) {
			commentText = "";
		}

		let metadata = null;

		try {
			if ( message?.attributes?.metadata && message.attributes.metadata.trim () !== "" ) {
				metadata = JSON.parse ( message.attributes.metadata );
			}
		} catch ( error ) {
			// If JSON parsing fails
			return;
		}

		if ( !metadata )
			return;

		const __data = metadata;

		if ( eventName === "SEND_MESSAGE" ) {

			if ( ( __data?.sportsFan?.id === userProfile?.id ) ) {

				if ( __data?.commentType === "STREAM_DONATION" ) {

					return updateComments ( __data );

				}
				if ( __data?.requestId === null || __data?.commentType === "MAGIC_CHAT" ) {

					return updateComments ( { ...__data, commentText } );
				}
			}

			let updatedData = { ...__data, commentText };

			updateComments ( updatedData );

		}

		if ( eventName === "CHAT_TIPS" ) {

			// dont render squad play or affiliate ad chat tips
			if ( __data?.chatTip?.ctaType === "AFFL_AD" || __data?.chatTip?.ctaType === "SQUAD_PLAY" )
				return;

			if ( __data ) {
				updateComments ( __data );
			}
		}

		if ( eventName === "DELETE_MESSAGE" ) {
			let comment = {};

			if ( __data?.deletedCommentId ) {
				comment["id"] = __data?.deletedCommentId;

				if ( !comment )
					return;

				setCommentsState ( prevState => prevState.filter ( item => item.id !== comment.id ) );

			}

		}

		if ( eventName === "USER_BLOCKED" ) {

			if ( __data?.authorId ) {
				setCommentsState ( prevState => prevState.filter ( item => item.sportsFan?.id !== __data.authorId ) );

			}
		}
	}, [ message ] );

	return { setMessage };
};

export default useIVS;